<ng-template #loading>
  <terra-loader [centerToParent]="true"></terra-loader>
</ng-template>
<ng-container *ngIf="accountDetails$ | async as accountDetails; else loading">
  <section class="header">
    <h1 class="lo_sensitive client-name">{{ accountDetails.firstName }} {{ accountDetails.lastName }}</h1>
    <span class="covercy-id"> Your Covercy ID: {{ accountDetails.clientIdentifier }}</span>
  </section>

  <div class="my-account-content">
    <mat-accordion displayMode="flat" class="container">
      <!-- Change password -->
      <mat-expansion-panel hideToggle #passwordPanel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon color="primary" class="circle-icon notranslate">lock_outline</mat-icon>
            <div>
              <span class="panel-title">Change password</span>
              <span class="extra-details">********</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <terra-change-password [model]="accountDetails"></terra-change-password>
      </mat-expansion-panel>


      <mat-expansion-panel hideToggle disabled *ngIf="(availableInvestingEntities$ | async)?.length && isMobileDevice" (click)="share()">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon color="primary" class="circle-icon notranslate">group_outline</mat-icon>
            <div>
              <span class="panel-title">Share</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
      </mat-expansion-panel>

      <!-- Support PIN -->
      <mat-expansion-panel hideToggle #supportPinPanel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon color="primary" class="circle-icon notranslate">call_outline</mat-icon>
            <div>
              <span class="panel-title">Support PIN</span>
              <span class="extra-details lo_sensitive">{{ supportPin$ | async }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <terra-support-pin [supportPin]="supportPin$ | async"></terra-support-pin>
      </mat-expansion-panel>

      <!-- email -->
      <mat-expansion-panel hideToggle #emailPanel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon color="primary" class="circle-icon notranslate">mail_outline</mat-icon>
            <div>
              <span class="panel-title">Change email</span>
              <span class="extra-details lo_sensitive">{{ accountDetails.email }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <terra-change-email [model]="accountDetails"></terra-change-email>
      </mat-expansion-panel>

      <!-- social login -->
      <mat-expansion-panel hideToggle #socialLoginPanel *ngIf="accountDetails.logins?.length > 0">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon color="primary" class="circle-icon notranslate" svgIcon="thumb_outline"></mat-icon>
            <div>
              Social login
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <terra-social-login [model]="accountDetails"></terra-social-login>
      </mat-expansion-panel>

      <!-- two factor authentication -->
      <mat-expansion-panel hideToggle #twoFactorAuthentication>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon color="primary" class="circle-icon notranslate">mobile_friendly_outline</mat-icon>
            <div>
              <span class="panel-title">Account security</span>
              <span class="extra-details">Two-factor authentication
                {{ accountDetails?.isTwoFactorAuthenticationEnabled ? 'enabled' : 'disabled' }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <terra-two-factor-authentication [model]="accountDetails"></terra-two-factor-authentication>
      </mat-expansion-panel>

      <!-- personal details -->
      <mat-expansion-panel hideToggle #personalDetailsPanel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon color="primary" class="circle-icon notranslate">person_outline</mat-icon>
            <div>
              <span class="panel-title">Personal details</span>
              <span class="lo_sensitive extra-details">{{ accountDetails.firstName + ' ' + accountDetails.lastName }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <terra-personal-details-lp [model]="accountDetails"></terra-personal-details-lp>
      </mat-expansion-panel>

      <!-- Company Profile -->
      <mat-expansion-panel hideToggle *ngIf="accountDetails.organizationDetails" #companyProfilePanel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon color="primary" svgIcon="business_center_outline" class="circle-icon notranslate"></mat-icon>
            <div>
              <span class="panel-title"> Company profile</span>
              <span class="lo_sensitive extra-details">
                {{ accountDetails.organizationDetails.name }}
              </span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <terra-company-profile-lp [model]="accountDetails"></terra-company-profile-lp>
      </mat-expansion-panel>
    </mat-accordion>

    <!-- Asset Bank Account Profile -->
    <!-- <mat-nav-list class="links-list container">
      <mat-list-item [routerLink]="routingService.bankAccountsAndCurrenciesLp">
        <mat-icon color="primary" mat-list-icon class="circle-icon notranslate">attach_money</mat-icon>
        <span class="bank-accounts-title" mat-line>Bank accounts & Currencies Preferences ></span>
      </mat-list-item>
      <a mat-list-item href="https://www.covercy.com/contact-us" target="_blank"> Contact Covercy </a>
      <a mat-list-item [routerLink]="logoutPath">Logout</a>
    </mat-nav-list> -->

    <img class="data-safe" src="/assets/images/icons/data-safe.png" />
  </div>
</ng-container>
